import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sessao-rodape',
  templateUrl: './sessao-rodape.component.html',
  styleUrls: ['./sessao-rodape.component.scss']
})
export class SessaoRodapeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
